<template>
  <component
    :is="component(content)"
    v-bind="content.props"
    :id="content.slug"
    :class="content.class"
    @backToContents="handleBackToContents"
  >
    {{ textContent(content) }}
    <template v-for="(slot, key) in slotContent(content)" #[key] :key="key">
      <RecursiveContent
        v-for="(childContent, childIndex) in slot"
        :key="childIndex"
        :content="childContent"
      />
    </template>
    <template v-if="content.children">
      <RecursiveContent
        v-for="(childContent, childIndex) in content.children"
        :key="childIndex"
        :content="childContent"
      />
    </template>
  </component>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { mapActions } from "vuex";

export default {
  name: "RecursiveContent",
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions("sustainability", ["toggleMenu"]),
    component(content) {
      if (content.tag) {
        return content.tag;
      }
      return defineAsyncComponent(() =>
        import(
          /* webpackChunkName: "[request]" */ `@/components/${content.component}.vue`
        )
      );
    },
    slotContent(item) {
      const slots = item.slot || {};
      const normalizedSlots = { ...slots };

      Object.keys(slots).forEach((slotName) => {
        if (slotName.includes("-")) {
          const camelCaseName = slotName.replace(/-([a-z])/g, (_, char) =>
            char.toUpperCase()
          );
          if (!normalizedSlots[camelCaseName]) {
            normalizedSlots[camelCaseName] = slots[slotName];
          }
        }
      });

      return normalizedSlots;
    },
    textContent(item) {
      if (!item) {
        return "";
      }
      if (typeof item.text === "string") {
        return item.text;
      }
      if (item.props && typeof item.props.text === "string") {
        return item.props.text;
      }
      return "";
    },
    handleBackToContents() {
      console.log("RecursiveContent: Back to contents event received");

      // Open the sustainability navigation menu to show main contents
      try {
        this.toggleMenu();
        console.log("RecursiveContent: Navigation menu toggled");
      } catch (error) {
        console.log(
          "RecursiveContent: Sustainability store not available",
          error
        );
      }
    },
  },
};
</script>
